<div [ngClass]="{'publishing': publishing}" #publisherDiv></div>
<!--
<button mat-fab color="primary" (click)="cycleVideo()"
    style="position:absolute; top:10px; right:10px; z-index:999">
    <i class="material-icons">switch_video</i>
</button>
-->